import { useState, type CSSProperties } from "react";
import { useTranslation } from "react-i18next";

type VideoPreviewProps = {
  src: string;
  className?: string;
  style?: CSSProperties;
  fallbackClassName?: string;
};

const VideoPreview = ({
  src,
  className = "",
  style,
  fallbackClassName = "text-sm text-gray-500 text-center px-2",
}: VideoPreviewProps) => {
  const { t } = useTranslation();
  const [undecodableSrc, setUndecodableSrc] = useState<string | null>(null);

  if (undecodableSrc === src) {
    return (
      <p className={fallbackClassName}>{t("pages.gallery.uploadPanel.videoPreviewUnavailable")}</p>
    );
  }

  return (
    <video
      controls
      src={src}
      style={style}
      className={className}
      onLoadedMetadata={(e) => {
        if (e.currentTarget.videoWidth === 0) setUndecodableSrc(src);
      }}
    />
  );
};

export default VideoPreview;
